/** Reading an approval request on a filing: whether one is open, and who has it, in words. Hooks and
 * a predicate, so they live apart from the components that draw them. */

import type { ApprovalRequest } from "../../api/work";
import { useNameOf } from "../PersonRef";

const OPEN = new Set(["pending", "adjustment_requested"]);

/** Whether a request is still waiting on somebody. */
export function isOpenRequest(request: Pick<ApprovalRequest, "state"> | null | undefined): boolean {
  return Boolean(request && OPEN.has(request.state));
}

/** Who has the request in front of them, in words: the name where the product shows one (the company
 * Admin's roster, `useNameOf`, which is the one home for that rule), otherwise "a named reviewer".
 * Never an identifier (rule 4). */
export function useReviewerWords(reviewerIds: readonly string[]): string {
  const nameOf = useNameOf();
  const names = reviewerIds.map((id) => nameOf(id));
  if (names.length > 0 && names.every(Boolean)) return names.join(", ");
  return reviewerIds.length > 1 ? "named reviewers" : "a named reviewer";
}
